






























import AppButtonNew from '@/uikit/components/AppButtonNew/AppButtonNew.vue';
import Arrow_up from '@/uikit/components/AppSvgIconNew/templates/icons/arrow_up.vue';
import Down from '@/uikit/components/AppSvgIconNew/templates/icons/down.vue';
import Apply from '@/uikit/components/AppSvgIconNew/templates/icons/apply.vue';
import { getColorByName } from '@/uikit/utils/colorUtils';
import { createGuid } from '@/uikit/utils/guide';
import AppSvgIcon from '@/uikit/components/AppSvgIconNew/AppSvgIcon.vue';

export default {
  name: 'AppComboboxMulti',
  props: {
    data: {
      type: Array,
    },
    value: Array,
    disabled: {
      type: Boolean,
      default: false,
    },
    filterable: {
      type: [Boolean, String],
      default: false,
      validator: (value: any) => typeof value === 'boolean' || value === 'auto',
    },
    placeholder: String,
  },
  components: {
    AppSvgIcon,
    AppButtonNew,
    Arrow_up,
    Down,
    Apply,
  },
  data() {
    return {
      selected: this.value || [],
      open: false,
      id: createGuid(),
      isToTop: false,
    };
  },
  computed: {
    getText() {
      return this.selected.length
        ? this.data
            .filter((el: any) => this.selected.includes(el.id))
            .map((el: any) => el.text)
            .join(', ')
        : this.placeholder
        ? this.placeholder
        : 'Не выбрано';
    },
    getSelectedData() {
      return this.data;
    },
    isPlaceholder() {
      return !this.selected.length;
    },
    getStyle() {
      return {
        '--ui_combobox_border': this.open
          ? '1px solid #279DF2'
          : '1px solid #B6B6B6',
        '--ui_combobox_radius': this.open ? 'null' : undefined,
        '--ui_combobox_border_bottom': this.open
          ? `1px solid ${getColorByName('#B6B6B6')}`
          : undefined,
      };
    },
  },
  mounted() {
    if (document) {
      let _id = this.id;
      document.addEventListener('click', (event: any) => {
        for (const pathElement of event.composedPath()) {
          if (pathElement.id === _id) {
            return;
          }
        }
        this.closeCombobox();
      });
    }
  },
  methods: {
    calculateTop() {
      this.isToTop = !!(
        typeof window !== 'undefined' &&
        this.$refs?.combobox &&
        window.innerHeight -
          this.$refs.combobox.getBoundingClientRect().bottom <
          210
      );
    },
    selectData(data: any) {
      const select = !this.selected.some((el: any) => data.id === el);
      if (select) {
        this.selected.push(data.id);
      } else {
        this.selected = this.selected.filter(
          (elem: any) => elem !== data.id
        );
      }
      this.$emit('input', this.selected);
    },
    toggleCombobox() {
      this.calculateTop();
      this.open ? this.closeCombobox() : this.openCombobox();
    },
    closeCombobox() {
      this.open = false;
    },
    openCombobox() {
      this.open = true;
    },
  },
};



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/uikit/components/AppComboBox/AppComboboxMulti.vue